<div class="base">
  <pp-common-components [ppFleetLoaded]="fleetExists"></pp-common-components>

  <div
    #fleetManagement
    class="fleetManagement"
    [class.fleetManagement--full-width]="!sidePanel.expandedInitially"
  >
    <router-outlet></router-outlet>
  </div>
</div>
